import { AgGrid } from "@jsq/ds/core";
import { type OverviewFilters, type OverviewSort } from "~/graphql/supergraphTypes";
import { AG_GRID_SET_FILTER_FIELDS } from "../../constants";

const isDateField = (field: string, columnDefs: AgGrid.ColDef[] | undefined): boolean => {
  if (!columnDefs) return false;

  const colDef = columnDefs.find((col) => col.field === field);
  return colDef?.filter === "agDateColumnFilter";
};

const isSetField = (
  field: string,
  columnDefs: AgGrid.ColDef[] | undefined,
  isBillingAgGridStaticSetFiltersFlagEnabled?: boolean,
): boolean => {
  if (isBillingAgGridStaticSetFiltersFlagEnabled && AG_GRID_SET_FILTER_FIELDS.includes(field)) {
    return true;
  }

  if (!columnDefs) return false;

  const colDef = columnDefs.find((col) => col.field === field);
  return colDef?.filter === "agSetColumnFilter";
};

export const overviewFiltersToFilterModel = (
  filters: OverviewFilters[] | null,
  columnDefs?: AgGrid.ColDef[],
  isBillingAgGridStaticSetFiltersFlagEnabled?: boolean,
): AgGrid.FilterModel | null => {
  if (!filters) return null;

  try {
    const filterModel: AgGrid.FilterModel = {};

    filters.forEach((filter) => {
      const { field, filterValues } = filter;
      if (!filterValues || filterValues.length === 0) {
        return;
      }

      if (isDateField(field, columnDefs)) {
        filterModel[field] = {
          filterType: "date",
          type: "equals",
          dateFrom: filterValues[0],
        };
      } else if (isSetField(field, columnDefs, isBillingAgGridStaticSetFiltersFlagEnabled)) {
        filterModel[field] = {
          filterType: "set",
          values: filterValues,
        };
      } else {
        filterModel[field] = {
          filterType: "text",
          type: "contains",
          filter: filterValues[0],
        };
      }
    });

    const result = Object.keys(filterModel).length > 0 ? filterModel : null;
    return result;
  } catch {
    return null;
  }
};

export const overviewSortsToSortModel = (
  sorts: OverviewSort[] | null,
): AgGrid.SortModelItem[] | null => {
  if (!sorts) return null;
  try {
    const result = sorts.map((sort) => {
      const sortDirection: "asc" | "desc" = sort.sortAscending ? "asc" : "desc";
      return {
        colId: sort.field,
        sort: sortDirection,
      };
    });
    return result;
  } catch {
    return null;
  }
};
